import useOnlineStatus from '../customHooks/useOnlineStatus';

export const NetworkStatus = () => {
    const isOnline = useOnlineStatus();
    return (
        <>{isOnline ? <div>// Connected</div> : <div>// Disconnected</div>}</>
    )
}